<template>
  <form v-on:submit.prevent="editBed">
    <div class="modal-card" >
      <header class="modal-card-head">
        <p class="modal-card-title">Editar datos de la cama</p>
        <button type="button" class="delete" @click="$emit('close')" />
      </header>
      <section class="modal-card-body">
          <b-loading :is-full-page="false" v-model="isLoading" :can-cancel="true"></b-loading>
        <b-field label="N° de cama">
            <b-input v-model="dataBed.n_cama"></b-input>
        </b-field>
        <b-field label="Estado de la cama por defecto" v-if="dataBed.state=='BLOQUEADA'">
            <b-select v-model="dataBed.state" expanded required>
                <option value="HABILITADA">HABILITADA</option>
                <option value="BLOQUEADA">BLOQUEADA</option>
            </b-select>
        </b-field>
        <b-field label="Establecimiento" v-if="!dataBed.patient_id">
            <b-select placeholder="Seleccionar Establecimiento" expanded v-model="dataBed.stablishment_id" @change.native="changeStablishment" required :disabled="!manteiner">
                <option
                    v-for="option in listStablishment"
                    :value="option.id"
                    :key="option.id">
                    {{ option.name }}
                </option>
            </b-select>
        </b-field>
        <b-field label="Categorización" v-if="!dataBed.patient_id">
            <b-select placeholder="Seleccionar Categorización" expanded v-model="dataBed.categorization_id" @change.native="changeCategorization" required>
                <option
                    v-for="option in listCategorization"
                    :value="option.id"
                    :key="option.id">
                    {{ option.name }}
                </option>
            </b-select>
        </b-field>
        <b-field label="Subcategorización" v-if="!dataBed.patient_id">
            <b-select placeholder="Seleccionar Subcategorización" expanded v-model="dataBed.subcategorization_id" required>
                <option
                    v-for="option in listSubCategorization"
                    :value="option.id"
                    :key="option.id">
                    {{ option.name }}
                </option>
            </b-select>
        </b-field>
        <b-field label="Resultado PCR" v-if="dataBed.patient_id">
            <b-select placeholder="Seleccionar opción" expanded v-model="dataBed.covid19" value="negativo" required>
                <option value="positivo">Positivo</option>
                <option value="sospecha">Sospecha</option>
                <option value="negativo">Negativo</option>
                <option value="no aplica">No aplica</option>
            </b-select>
        </b-field>
        <b-field label="Paciente con ventilador" v-if="dataBed.patient_id && dataBed.ventilator == 'si'">
            <b-select placeholder="Seleccionar opción" expanded v-model="dataBed.ventilator_used" required>
                 <option value="si">Si</option>
                <option value="no">No</option>
            </b-select>
        </b-field>
        <b-field label="Cama con ventilador" v-if="changeVentilator">
            <b-select placeholder="Seleccionar opción" expanded v-model="dataBed.ventilator" required>
                 <option value="si">Si</option>
                <option value="no">No</option>
            </b-select>
        </b-field>
        <b-field label="Diagnóstico" v-if="false">
            <b-input v-model="dataBed.diagnostic" type="textarea"></b-input>
        </b-field>
      </section>
      <footer class="modal-card-foot">
        <button class="button" type="button" @click="$emit('close')" >
          Cerrar
        </button>
        <button class="button is-primary" type="submit">Guardar</button>
      </footer>
    </div>
  </form>
</template>
<script>
import { PutBed } from '../../services/beds';
import { CategorizationFindByStablishmentId } from '../../services/categorization';
import {GetAllStablishment} from '../../services/stablishment';
import { SubCategorizationFindByCategorizationId } from '../../services/subCategorization';
import { eventBus } from "../../main";

export default {
    props:['bed','manteiner', 'changeVentilator'],
    data(){
        return{
            dataBed:{
                ...this.bed,
                ventilator: this.bed.ventilator == null ? 'no' : this.bed.ventilator,
                covid19:this.bed.covid19!==null?this.bed.covid19:'negativo'
                },
            listStablishment:[],
            listCategorization:[],
            listSubCategorization:[],
            isLoading:false,
        }
    },
    mounted(){
        this.chargeData();
    },
    methods:{
        async chargeData(){
            this.isLoading=true;
            this.listStablishment=await GetAllStablishment(this.$http);
            this.listCategorization=await CategorizationFindByStablishmentId(this.$http,this.dataBed.stablishment_id);
            this.listSubCategorization=await SubCategorizationFindByCategorizationId(this.$http,this.dataBed.categorization_id);
            this.isLoading=false;
        },
        async editBed(){
            this.isLoading=true;
            try {
                await PutBed(this.$http,this.bed.id,this.dataBed);
                eventBus.$emit('loadBedList');          
                eventBus.$emit('rechargeTableManteinerBeds'); 
                this.toast("La cama se ha actualizado correctamente", "is-success");
            } catch (error) {
                console.log(error);
                this.toast("Lo sentimos, ha ocurrido un error", "is-danger");
            }
            this.$parent.close();  
            this.isLoading=false;
        },
        async changeStablishment(){
            this.isLoading=true;
            this.listCategorization=await CategorizationFindByStablishmentId(this.$http,this.dataBed.stablishment_id);
            this.dataBed.categorization_id=null;
            this.dataBed.subcategorization_id=null;
             this.isLoading=false;
        },
        async changeCategorization(){
            this.isLoading=true;
            this.listSubCategorization=await SubCategorizationFindByCategorizationId(this.$http,this.dataBed.categorization_id);            
            this.dataBed.subcategorization_id=null;
            this.isLoading=false;
        }
    }
}
</script>